/* Cookie consent: first layer, footer link, cleanup, proof of consent (theme group 79b; design: docs/shop-search/consent/DESIGN.md). NO WORDS here: they arrive in #lc-consent-data.
   Shopify's Customer Privacy API stores the decision; this file adds no cookie or storage key and only DELETES keys the inventory names. Pure functions are exported for node (79b-consent-logic.test.mjs). */
(function () {
  'use strict'

  // ---- bots, speed tests, headless browsers: no layer, no API call (DESIGN 6); one fragment per group
  const BOT_TOKENS = [
    'googlebot|google-inspectiontool|googleother|adsbot-google|mediapartners-google|apis-google|storebot-google|google-read-aloud|bingbot|bingpreview|msnbot|adidxbot|duckduckbot|slurp|baiduspider|yandex(?:[a-z]*bot|images|metrika)|sogou|exabot|applebot|seznambot|petalbot|qwantify|coccocbot',
    'ahrefsbot|ahrefssiteaudit|semrushbot|mj12bot|dotbot|rogerbot|blexbot|dataforseo|serpstat|screaming frog|sitebulb|deepcrawl|prerender',
    'facebookexternalhit|facebot|twitterbot|linkedinbot|pinterestbot|pinterest/0\\.|slackbot|slack-imgproxy|discordbot|whatsapp/|telegrambot|skypeuripreview|embedly',
    'gptbot|chatgpt-user|oai-searchbot|claudebot|claude-web|anthropic-ai|perplexitybot|perplexity-user|ccbot|bytespider|amazonbot|cohere-ai',
    'chrome-lighthouse|lighthouse|google page speed|pagespeed|speed insights|gtmetrix|pingdom|webpagetest|ptst/|dareboost|catchpoint|uptimerobot|statuscake|site24x7|newrelicpinger|datadog|speedcurve|calibre|sitespeed|yellowlab',
    'headlesschrome|phantomjs|puppeteer|playwright|selenium|curl/|wget/|python-requests|python-urllib|aiohttp|go-http-client|java/|okhttp|libwww-perl|scrapy|node-fetch|axios/|undici',
    '\\bbot\\b|\\bcrawler\\b|\\bspider\\b|\\bcrawl\\b',
  ]
  const BOT_RE = new RegExp(BOT_TOKENS.join('|'), 'i')
  const isAutomated = (n) => !!n && (n.webdriver === true || ((n.userAgentData && n.userAgentData.brands) || []).some((b) => /headless/i.test(b.brand)) || BOT_RE.test(n.userAgent || ''))

  // ---- the three switches to Shopify's four fields (DESIGN 3); under GPC marketing is never true
  const toApi = (c, gpc) => {
    const m = gpc ? false : !!c.marketing
    return { preferences: !!c.preferences, analytics: !!c.statistics, marketing: m, sale_of_data: m }
  }
  const call = (o, f) => (o && typeof o[f] === 'function' ? !!o[f]() : false)
  /** what the switches show: the decision, else what Shopify allows now */
  const toggleState = (cp, gpc) => {
    const cur = (cp && typeof cp.currentVisitorConsent === 'function' && cp.currentVisitorConsent()) || {}
    const pick = (field, allowed) => (cur[field] === 'yes' ? true : cur[field] === 'no' ? false : call(cp, allowed))
    return { preferences: pick('preferences', 'preferencesProcessingAllowed'), statistics: pick('analytics', 'analyticsProcessingAllowed'), marketing: gpc ? false : pick('marketing', 'marketingAllowed') }
  }
  const allowedNow = (cp) => ({ preferences: call(cp, 'preferencesProcessingAllowed'), statistics: call(cp, 'analyticsProcessingAllowed'), marketing: call(cp, 'marketingAllowed') })
  /** Is a first layer due? shouldShowBanner() is only the region flag and stays true after a decision: the visitor has decided when getTrackingConsent() is not 'no_interaction' */
  const bannerDue = (cp) => {
    try {
      if (!cp) return false
      if (typeof cp.shouldShowGDPRBanner === 'function') return !!cp.shouldShowGDPRBanner()
      return call(cp, 'shouldShowBanner') && (typeof cp.getTrackingConsent !== 'function' || cp.getTrackingConsent() === 'no_interaction')
    } catch (e) { return false }
  }
  /** why no layer ('' = it shows) */
  const layerVerdict = (o) => (o.automated ? 'bot' : !o.api || !(o.api.shouldShowGDPRBanner || o.api.shouldShowBanner) ? 'no-api' : !bannerDue(o.api) ? 'not-due' : o.yieldTo ? 'yield' : '')
  /** GPC and no layer due: one quiet opt-out of the sale of data; a throwing API costs nothing else */
  const quietGpc = (cp, gpc) => {
    if (!gpc || !cp || typeof cp.setTrackingConsent !== 'function' || bannerDue(cp)) return false
    const cur = (typeof cp.currentVisitorConsent === 'function' && cp.currentVisitorConsent()) || {}
    if (cur.sale_of_data !== '') return false
    try { cp.setTrackingConsent({ sale_of_data: false }, () => {}) } catch (e) { return false }
    return true
  }

  // ---- the API: the one that exists, else loadFeatures 0.2; cb(api, failed) within 5 s (api null and failed false: slow)
  function whenApi(W, cb, wait) {
    let done = false
    const fin = (failed) => { if (!done) { done = true; const a = (W.Shopify && W.Shopify.customerPrivacy) || null; cb(a, !a && failed === true) } }
    if (W.Shopify && W.Shopify.customerPrivacy) return fin()
    if (!W.Shopify || typeof W.Shopify.loadFeatures !== 'function') return fin(true)
    wait(fin, 5000)
    try { W.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => fin(true)) } catch (e) { fin(true) }
  }

  // ---- cleanup (categories that are off) and tombstones (leftovers of removed vendors): only DELETE what the inventory lists
  const globRe = (g) => new RegExp('^' + g.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*') + '$')
  const domains = (host) => { const p = String(host || '').split('.'); const o = ['']; for (let i = 0; i < p.length - 1; i++) o.push(p.slice(i).join('.')); return o }
  function sweep(list, env) {
    const gone = []
    for (const it of list || []) {
      const re = it.n.indexOf('*') > -1 ? globRe(it.n) : null
      if (it.k === 'ck') {
        const have = String(env.doc.cookie || '').split(';').map((s) => s.split('=')[0].trim()).filter(Boolean)
        for (const n of have.filter((x) => (re ? re.test(x) : x === it.n))) {
          for (const d of domains(env.host)) env.doc.cookie = n + '=; Max-Age=0; path=/' + (d ? '; domain=' + d : '') // consent-key: @inventory
          gone.push(n)
        }
      } else {
        try {
          const st = it.k === 'ls' ? env.ls : env.ss
          for (const k of re ? Object.keys(st).filter((x) => re.test(x)) : st.getItem(it.n) !== null ? [it.n] : []) { st.removeItem(k); gone.push(k) } // consent-key: @inventory
        } catch (e) { /* blocked storage: nothing to delete */ }
      }
    }
    return gone
  }
  const offList = (cleanup, allowed) => (cleanup || []).filter((x) => !allowed[x.c])

  // ---- Consent Mode update (only when the data block says gcm)
  const gcmUpdate = (a) => {
    const g = (v) => (v ? 'granted' : 'denied')
    return { ad_storage: g(a.marketing), ad_user_data: g(a.marketing), ad_personalization: g(a.marketing), analytics_storage: g(a.statistics), functionality_storage: g(a.preferences), personalization_storage: g(a.preferences) }
  }

  // ---- proof of consent: nothing personal, ref = SHA-256 of Shopify's consent id; fire and forget
  const sha256hex = (s, subtle) => {
    try {
      if (!s || !subtle || typeof TextEncoder === 'undefined') return Promise.resolve(null)
      return subtle.digest('SHA-256', new TextEncoder().encode(s)).then((b) => Array.from(new Uint8Array(b), (x) => x.toString(16).padStart(2, '0')).join(''), () => null)
    } catch (e) { return Promise.resolve(null) }
  }
  const receiptBody = (o) => ({
    version: o.version, via: o.via, preferences: !!o.payload.preferences, statistics: !!o.payload.analytics, marketing: !!o.payload.marketing,
    saleOfData: !!o.payload.sale_of_data, gpc: !!o.gpc, bannerShown: !!o.shown,
    region: /^[A-Z]{2}[A-Z0-9]{0,3}$/.test(o.region || '') ? o.region : '', lang: o.lang, host: o.host, ref: o.ref || null,
  })
  /** the visitor's token for the receipt: one GET of /api/shop-session after the decision, null on failure or after 2 s (the receipt then goes into the shared bucket) */
  const TOKEN = /^st1\.[\w-]{56}\.[\w-]{43}$/
  function mintToken(F, url, wait) {
    if (!url) return Promise.resolve(null)
    const get = new Promise((res) => {
      try { Promise.resolve(F(url, { credentials: 'omit', referrerPolicy: 'no-referrer', cache: 'no-store' })).then((r) => (r && r.ok ? r.json() : null)).then((j) => res(j && j.data && TOKEN.test(j.data.st) ? j.data.st : null), () => res(null)) } catch (e) { res(null) }
    })
    return Promise.race([get, new Promise((res) => wait(() => res(null), 2000))])
  }
  function sendReceipt(F, url, body, wait) {
    const go = () => { try { return Promise.resolve(F(url, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body), keepalive: true, credentials: 'omit' })) } catch (e) { return Promise.reject(e) } }
    return go().then((r) => !!(r && r.ok), () => new Promise((res) => wait(() => go().then((r) => res(!!(r && r.ok)), () => res(false)), 2000)))
  }

  // ---- the layer waits for its sheet, asked of the cascade (--lcc-sheet on the root; link.sheet proves nothing after a 404). A failed or SHEET_WAIT-late sheet gets the plain FALLBACK look
  const FALLBACK = 'position:fixed;left:0;right:0;bottom:0;max-height:90vh;overflow:auto;background:#fff;color:#222;padding:16px;z-index:2147483647;border-top:4px solid #ff9731'
  const SHEET_WAIT = 8000
  const HOLD = 10000 // ms a footer click waits for a slow API after whenApi's 5 s
  const hasSheet = (el, cs, mark = '--lcc-sheet') => { try { return cs(el).getPropertyValue(mark).trim() === '1' } catch (e) { return false } }
  const rootStyle = (inSheet) => (inSheet ? '' : FALLBACK)
  /** f now if the link holds a sheet, else on load, error and after ms (f is idempotent) */
  function whenSheet(link, f, wait, ms) {
    if (link.sheet) return f()
    link.addEventListener('load', f); link.addEventListener('error', f); wait(f, ms)
  }

  // ---- Shopify's t filter escapes & < > " ' in every key but *_html and json keeps it: decode the words once (purposes and names are literals)
  const ENT = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", '#39': "'", '#x27': "'" }
  const unescapeT = (s) => (typeof s === 'string' ? s.replace(/&(amp|lt|gt|quot|apos|#39|#x27);/g, (m, e) => ENT[e]) : s)
  function decodeData(d) {
    for (const k in (d && d.t) || {}) d.t[k] = unescapeT(d.t[k])
    for (const c of (d && d.cfg && d.cfg.cats) || []) for (const v of c.vendors || []) for (const e of v.entries || []) { e.k = unescapeT(e.k); e.d = unescapeT(e.d) }
    return d
  }

  // ---- the decision: one setTrackingConsent call with all four fields; cb(error|null, payload)
  function apply(cp, choice, gpc, cb, wait) {
    const payload = toApi(choice, gpc)
    let done = false
    const fin = (err) => { if (!done) { done = true; cb(err || null, payload) } }
    wait(() => fin(new Error('timeout')), 8000)
    try { cp.setTrackingConsent(payload, fin) } catch (e) { fin(e) }
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { BOT_TOKENS, BOT_RE, isAutomated, toApi, toggleState, allowedNow, bannerDue, layerVerdict, quietGpc, whenApi, globRe, domains, sweep, offList, gcmUpdate, sha256hex, receiptBody, mintToken, sendReceipt, apply, FALLBACK, SHEET_WAIT, hasSheet, rootStyle, whenSheet, unescapeT, decodeData }
  }
  if (typeof document === 'undefined' || typeof window === 'undefined') return

  // ================================================================== browser part
  const W = window
  const D = document
  const dataEl = D.getElementById('lc-consent-data')
  if (!dataEl || W.LCConsent || isAutomated(navigator) || (W.Shopify && W.Shopify.designMode)) return // the theme editor's preview shows no layer
  let data
  try { data = decodeData(JSON.parse(dataEl.textContent)) } catch (e) { return }
  const T = data.t || {}
  const C = data.cfg || { cats: [], cleanup: [], tomb: [], sw: {} }
  const gpc = navigator.globalPrivacyControl === true || navigator.globalPrivacyControl === '1' // boolean per spec; Shopify also reads "1"
  const wait = (f, ms) => setTimeout(f, ms)
  const store = (n) => { try { return W[n] } catch (e) { return null } }
  const env = { doc: D, host: location.hostname, ls: store('localStorage') || {}, ss: store('sessionStorage') || {} }

  const SVG = {
    x: '<path d="M6 6l12 12M18 6L6 18"/>', check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
  }
  const svg = (k, s) => `<svg width="${s}" height="${s}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${SVG[k]}</svg>`
  const h = (tag, cls, props, ...kids) => {
    const e = D.createElement(tag)
    if (cls) e.className = cls
    for (const k in props || {}) { if (k === 'text') e.textContent = props[k]; else if (k === 'html') e.innerHTML = props[k]; else e.setAttribute(k, props[k]) }
    for (const x of kids) if (x) e.append(x)
    return e
  }
  const btn = (cls, act, text, extra) => h('button', 'lcc-btn ' + cls, Object.assign({ type: 'button', 'data-lcc': act, text }, extra))

  let api = null
  let root = null
  let live = null
  let layer = null
  let toast = null
  let toastTimer = 0
  let dialog = null
  let dialogLoad = null
  let cssLink = null
  let shown = false
  let ready = false
  let busy = false
  const waiting = []

  const say = (txt) => { if (live) { live.textContent = ''; wait(() => { live.textContent = txt }, 30) } }
  const linkOnce = (href) => {
    let l = D.querySelector('link[data-lcc-css="' + href + '"]')
    if (!l) { l = h('link', '', { rel: 'stylesheet', href, 'data-lcc-css': href }); D.head.append(l) }
    return l
  }
  const css = () => cssLink || (cssLink = linkOnce(data.css))
  /** the root stays display:none until the sheet is in; runs on load, error and SHEET_WAIT, as often as needed */
  const reveal = () => { if (root) root.style.cssText = rootStyle(hasSheet(root, (e) => W.getComputedStyle(e))) }
  const styled = (f) => whenSheet(css(), f, wait, SHEET_WAIT)
  // ---- WCAG 2.4.11: focus is never entirely behind the layer or the confirmation: the page keeps scroll-padding-bottom their height, and room below when the end of the page is not enough (layout, not
  // getBoundingClientRect: the entrance animation moves the box)
  const docEl = D.documentElement
  const padOf = () => { const el = layer || toast; if (!el) return 0; const b = parseFloat(W.getComputedStyle(el).bottom); const n = isNaN(b) ? root.offsetHeight : el.offsetHeight + b; return n ? n + 8 : 0 } // NaN: the plain look
  let ro = null
  const pad = () => { const p = padOf(); docEl.style.scrollPaddingBottom = p ? p + 'px' : ''; if (!p) docEl.style.paddingBottom = '' }
  const watch = (el) => { if (W.ResizeObserver) (ro = ro || new W.ResizeObserver(pad)).observe(el); pad() }
  D.addEventListener('focusin', (e) => {
    const o = layer || toast
    const t = e.target
    if (!o || !t.getBoundingClientRect || o.contains(t)) return
    W.requestAnimationFrame(() => {
      const a = t.getBoundingClientRect()
      const b = o.getBoundingClientRect()
      if (a.bottom > b.top && a.top < b.bottom && a.right > b.left && a.left < b.right) { docEl.style.paddingBottom = padOf() + 'px'; t.scrollIntoView({ block: 'nearest' }) }
    })
  })
  const rootEl = () => {
    if (root) return root
    root = h('div', 'lcc', { 'data-lcc-root': '', lang: data.lang, style: 'display:none' })
    live = h('p', 'lcc-sr', { role: 'status', 'aria-live': 'polite' })
    root.append(live)
    const skip = D.querySelector('a.skip-to-content') || D.querySelector('a[href="#main"]')
    if (skip) skip.after(root); else D.body.prepend(root)
    root.addEventListener('click', onRootClick)
    watch(root)
    return root
  }

  // ---- decision: the layer closes first, the receipt follows and may fail unseen
  function decide(via, choice) {
    if (busy) return Promise.resolve(false)
    busy = true
    const hadFocus = !!layer && layer.contains(D.activeElement) // noted before visitorConsentCollected closes the layer
    const byKey = hadFocus && (() => { try { return D.activeElement.matches(':focus-visible') } catch (e) { return true } })()
    return new Promise((resolve) => {
      apply(api, choice, gpc, (err, payload) => {
        busy = false
        if (err) return resolve(false)
        afterDecision(via, payload, hadFocus, byKey)
        resolve(true)
      }, wait)
    })
  }
  function afterDecision(via, payload, hadFocus, byKey) {
    sweep(offList(C.cleanup, allowedNow(api)), env)
    gcm()
    closeLayer()
    showToast(hadFocus, byKey)
    say(T.saved || '')
    W.dispatchEvent(new CustomEvent('lc:consent', { detail: { via, consent: payload, gpc } }))
    const region = typeof api.getRegion === 'function' ? api.getRegion() : ''
    const id = typeof api.consentId === 'function' ? api.consentId() : ''
    sha256hex(id, W.crypto && W.crypto.subtle).then((ref) => {
      const body = receiptBody({ version: C.version, via, payload, gpc, shown, region, lang: data.lang, host: location.host, ref })
      const f = (u, o) => W.fetch(u, o)
      return mintToken(f, data.st, wait).then((st) => sendReceipt(f, (data.log || '/apps/lc/consent') + (st ? '?st=' + st : ''), body, wait))
    }).catch(() => {})
  }
  function gcm() {
    if (!(C.sw && C.sw.gcm) || !api) return
    const g = W.gtag || function () { (W.dataLayer = W.dataLayer || []).push(arguments) }
    g('consent', 'update', gcmUpdate(allowedNow(api)))
  }

  // ---- the location suggestion goes first (DESIGN 12.2): consent is per domain and a market switch lands on another one. lc-geo.js sets data-lc-geo on <html> (pending | open | done | none; absent: not
  // running) and fires lc:geo. cb runs after DOMContentLoaded (the deferred geo script has run) and once it is not open; pending and that wait share a 4 s cap, open has none; never over another script's open dialog
  let dcl = D.readyState === 'complete'
  if (!dcl) D.addEventListener('DOMContentLoaded', () => { dcl = true })
  function afterGeo(cb) {
    let capped = false
    let done = false
    let poll = 0
    const tick = () => {
      if (done) return
      const s = D.documentElement.getAttribute('data-lc-geo')
      if (s === 'open' || (!capped && (!dcl || s === 'pending'))) return
      if (D.querySelector('dialog[open]:not(.lcc-modal)')) { poll = poll || wait(() => { poll = 0; tick() }, 500); return }
      done = true
      cb()
    }
    wait(() => { capped = true; tick() }, 4000)
    D.addEventListener('lc:geo', tick)
    D.addEventListener('DOMContentLoaded', tick)
    tick()
  }

  // ---- first layer: non-modal, right after the skip link
  const blocked = () => layer || !api || layerVerdict({ api, yieldTo: !!D.getElementById('pandectes-banner') })
  let held = false
  function showLayer() {
    if (blocked() || held) return
    held = true
    afterGeo(() => { held = false; if (!blocked()) draw() })
  }
  function draw() {
    shown = true
    const r = rootEl()
    const links = h('p', 'lcc-banner__links')
    if (data.decl) links.append(h('a', '', { href: data.decl, text: T.link_declaration }))
    if (data.privacy) links.append(h('a', '', { href: data.privacy, text: T.link_privacy }))
    layer = h('section', 'lcc-banner', { role: 'dialog', 'aria-modal': 'false', 'aria-labelledby': 'lcc-b-title', 'aria-describedby': 'lcc-b-text' },
      h('h2', 'lcc-banner__title', { id: 'lcc-b-title', text: T.banner_title }),
      h('p', 'lcc-banner__text', { id: 'lcc-b-text', text: T.banner_text }),
      links.firstChild ? links : null,
      h('div', 'lcc-banner__actions', null,
        btn('lcc-btn--choice', 'reject', T.reject_all), btn('lcc-btn--choice', 'accept', T.accept_all),
        btn('lcc-btn--quiet', 'settings', T.settings, { 'aria-haspopup': 'dialog' })))
    r.append(layer)
    watch(layer)
    styled(reveal)
  }
  const closeLayer = () => { if (layer) { layer.remove(); layer = null; pad() } }
  const layerError = () => { if (layer && !layer.querySelector('.lcc-error')) layer.insertBefore(h('p', 'lcc-error', { role: 'alert', text: T.error }), layer.querySelector('.lcc-banner__actions')) }
  // gone after 6 s; a keyboard user on it keeps it, 4 rounds at most (a clicked button has the focus too)
  function showToast(focus, byKey) {
    clearToast()
    rootEl().append((toast = h('div', 'lcc-toast', null, h('span', '', { html: svg('check', 20) }), h('p', 'lcc-toast__text', { text: T.saved }),
      h('button', 'lcc-toast__link', { type: 'button', 'data-lcc': 'settings', text: T.change }),
      h('button', 'lcc-x', { type: 'button', 'data-lcc': 'toast-close', 'aria-label': T.close, html: svg('x', 20) }))))
    watch(toast)
    styled(reveal)
    if (focus) toast.querySelector('.lcc-toast__link').focus()
    let n = 0
    const tick = () => { if (toast && byKey && toast.contains(D.activeElement) && ++n < 4) toastTimer = wait(tick, 6000); else clearToast() }
    toastTimer = wait(tick, 6000)
  }
  function clearToast() { clearTimeout(toastTimer); if (toast) { toast.remove(); toast = null; pad() } }
  function onRootClick(e) {
    const b = e.target.closest && e.target.closest('[data-lcc]')
    if (!b) return
    const act = b.getAttribute('data-lcc')
    const run = (via, c) => decide(via, c).then((ok) => { if (!ok) layerError() })
    if (act === 'reject') run('reject_all', { preferences: false, statistics: false, marketing: false })
    else if (act === 'accept') run('accept_all', { preferences: true, statistics: true, marketing: true })
    else if (act === 'settings') open(b)
    else if (act === 'toast-close') clearToast()
  }

  // ---- the dialog: code and styles are fetched on the first open; it opens when the script and both sheets are in, else the declaration page
  function loadDialog() {
    if (!dialogLoad) {
      dialogLoad = new Promise((ok, no) => {
        const fail = () => no(new Error('dialog'))
        const check = () => { if (W.LCConsentDialog && ['--lcc-sheet', '--lcc-dsheet'].every((m) => hasSheet(rootEl(), (e) => W.getComputedStyle(e), m))) ok(W.LCConsentDialog) }
        for (const l of [css(), linkOnce(data.dcss)]) { l.addEventListener('load', check); l.addEventListener('error', fail) }
        if (!W.LCConsentDialog) {
          const sc = h('script', '', { src: data.djs, async: '' })
          sc.addEventListener('load', check)
          sc.addEventListener('error', fail)
          D.head.append(sc)
        }
        wait(fail, 8000)
        check()
      })
      dialogLoad.catch(() => { dialogLoad = null })
    }
    return dialogLoad
  }
  function open(opener) {
    const go = () => {
      if (!api) { if (data.decl) location.assign(data.decl); return }
      loadDialog().then((make) => {
        dialog = dialog || make({ doc: D, t: T, cats: C.cats, gpc, toggles: () => toggleState(api, gpc), decide, wait, fallbackFocus: () => toast && toast.querySelector('.lcc-toast__link') })
        dialog.open(opener)
      }, () => { if (data.decl) location.assign(data.decl) })
    }
    if (ready) go(); else waiting.push(go)
  }
  // capture phase: the theme cancels every [href^="#"] click
  D.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('[data-lc-consent-open], a[href="#cookie-settings"]')
    if (a) { e.preventDefault(); e.stopPropagation(); open(a) }
  }, true)
  W.LCConsent = { open, version: C.version }

  // ---- the declaration page's panel "Your current choice": one chip per category; the section keeps the panel hidden until it is filled
  function chips() {
    const box = D.querySelector('[data-lc-consent-chips]')
    if (!box || !api) return
    const s = toggleState(api, gpc)
    box.replaceChildren(...['necessary', 'preferences', 'statistics', 'marketing'].map((id) => {
      const on = id === 'necessary' || s[id]
      return h('li', 'lc-decl__chip lc-decl__chip--' + (on ? 'on' : 'off'), { html: svg(on ? 'check' : 'x', 14) }, h('span', '', { text: T['cat_' + id] + ': ' + (id === 'necessary' ? T.always_on : on ? T.on : T.off) }))
    }))
    box.closest('[data-lc-consent-status]').hidden = false
  }
  // ---- start: tombstones (always), cleanup, quiet GPC opt-out, the layer when due
  function sync() {
    if (!api) return
    sweep(offList(C.cleanup, allowedNow(api)), env)
    gcm()
    chips()
    if (layer && layerVerdict({ api })) closeLayer()
    if (dialog) dialog.refresh()
  }
  const flush = () => { ready = true; waiting.splice(0).forEach((f) => f()) }
  /** the first call that holds the API counts; nothing failing here may lose the waiting footer click */
  function boot(cp) {
    if (api) return
    api = cp
    try {
      if (cp) {
        D.addEventListener('visitorConsentCollected', sync)
        sweep(offList(C.cleanup, allowedNow(cp)), env)
        quietGpc(cp, gpc)
        gcm()
        showLayer()
        chips()
      }
    } catch (e) { /* the footer link still works */ }
    flush()
  }
  function start() {
    sweep(C.tomb, env) // leftovers of removed keys and vendors go whether or not the API ever loads: deleting needs no decision
    // Shopify's event: an API that comes late, or whose state loads late, still draws the layer
    D.addEventListener('consentTrackingApiLoaded', () => { const cp = W.Shopify && W.Shopify.customerPrivacy; if (!cp) return; if (api) { sync(); showLayer() } else boot(cp) })
    whenApi(W, (cp, failed) => {
      if (cp || failed) return boot(cp)
      wait(() => !api && flush(), HOLD) // slow, not failed: the footer click waits
    }, wait)
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start()
})()
